import { useDocumentReadingRunFinishWatch } from './useDocumentReadingRunFinishWatch';

interface DocumentReadingRunFinishWatcherProps {
  runId: string;
  /** True for a run started after the chat opened, whose first look may already be finished. */
  isNewInSession: boolean;
}

/** Follows one docked run for as long as the dock lists it, apart from its strip, which tucks away once
 * the run settles: the finish messages still reach the chat after that. Draws nothing. */
export function DocumentReadingRunFinishWatcher({
  runId,
  isNewInSession,
}: Readonly<DocumentReadingRunFinishWatcherProps>) {
  useDocumentReadingRunFinishWatch(runId, isNewInSession);
  return null;
}
